import { useContext, useMemo } from 'react';
import { translationsNamespaceContext } from './translationsNamespaceContext';
import { translationsContext } from '../TranslationsProvider';

/**
 * Props for the TranslationsNamespaceProvider component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Provider which provides translations namespace context to its children.
 *
 * @param props The namespace configuration for which translations are being provided.
 */
export const TranslationsNamespaceProvider = ({
  namespace,
  children
}) => {
  /**
   * Checks if the provided namespace exists in the translationsWithNamespaces object.
   * Throws an error if the namespace is not found.
   */
  const {
    translationsWithNamespaces
  } = useContext(translationsContext);
  const namespaceExists = translationsWithNamespaces ? Object.hasOwn(translationsWithNamespaces, namespace) : false;
  if (!namespaceExists && translationsWithNamespaces && Object.values(translationsWithNamespaces).length > 0) {
    throw new Error(`Entered namespace ${namespace} does not exists in translations object ${JSON.stringify(translationsWithNamespaces)} in TranslationsProvider or provided namespace has no translations`);
  }
  const contextValue = useMemo(() => ({
    namespace
  }), [namespace]);
  return /*#__PURE__*/_jsx(translationsNamespaceContext.Provider, {
    value: contextValue,
    children: children
  });
};
//# sourceMappingURL=TranslationsNamespaceProvider.js.map